<template>
  <div class="transfer-wrapper">
    <CustomDialog :visible="showDialog" @confirm="setTransferStatus" @close="showDialog = false" title="Confirmed" >
      <template v-slot:body>
        <p class="label">References: </p>
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 6}"
          placeholder="Please input"
          v-model="reference">
        </el-input>
        <p
          v-if="status === 3"
          class="label"
        >
          Amount:
        </p>
        <el-input
          v-if="status === 3"
          placeholder="Please input"
          type="number"
          v-model="amount"
        />
      </template>
    </CustomDialog>
    <table class="striped">
      <thead>
      <tr>
        <th>Client ID</th>
        <th>Login</th>
        <th>Name</th>
        <th>Transfer ID</th>
        <th>From Account</th>
        <th>To Account</th>
        <th>Amount</th>
        <th>Reference</th>
        <th>Status</th>
        <th>Action</th>
      </tr>
      </thead>

      <tbody>
        <IntraTransferRow
          v-for="(item, index) in transfer_list"
          :key="item.id"
          :item=item
          @setTransferStatus="openDialog"
          :class="{'greyRow': index % 2 === 0}"
        />
      </tbody>
    </table>
  </div>
</template>

<script>
  import IntraTransferRow from "./IntraTransferRow";
  import CustomDialog from "../CustomDialog";
  import { integer, required } from "vuelidate/lib/validators";

  export default {
    data: ()=>({
      transfer_list: [],
      showDialog: false,
      status: null,
      transfer: null,
      reference: '',
      amount: null,
    }),

    validations: {
      amount: { integer },
      reference: {required},
    },

    async mounted() {
      await this.loadTransfers();
    },

    methods: {
      async loadTransfers (){
        this.transfer_list = await this.$store.dispatch('request', {
          path: 'admin/gets/intras/transfers/lists', body: {}
        })
      },

      openDialog({ transfer, status }) {
        this.status = status
        this.transfer = transfer
        this.showDialog = true
      },

      async setTransferStatus(mode) {
        this.showDialog = false

        if (this.$v.$invalid || mode === 'close') {
          this.$v.$touch()
          return
        }

        const { transfer, status, reference, amount } = this
        await this.$store.dispatch('request', {
          path: 'admin/changes/intras/transfers/statuses',
          body: { transfer, status, reference, amount: amount || 0 }
        });

        await this.loadTransfers()
        this.status = null
        this.transfer = null
        this.reference = ''
        this.amount = null
      }
    },

    components:{
      IntraTransferRow,
      CustomDialog,
    },

  }
</script>

<style lang="scss" scoped>
  .transfer-wrapper {
    padding: 0 40px;
  }

  .label {
    margin-bottom: 10px;
    font-size: 16px;
  }

  .greyRow {
    background-color: rgba(211,211,211, 0.8) !important;
  }
</style>
